import { Pipe, PipeTransform } from '@angular/core';
import { FilterInterface, ScoringRuleInterface } from '@vendasta/crm';

@Pipe({ name: 'firstRuleFilter' })
export class FirstRuleFilterPipe implements PipeTransform {
  transform(rule: ScoringRuleInterface): FilterInterface {
    return rule.objectRules?.[0]?.filter ?? {};
  }
}
